import { IExcursionsOrder } from 'entities/excursions/models/order-excursions/model'

import { clientApi } from 'shared/api/clientApi'
import { refreshOrdersCount } from 'shared/api/orders-count-query'
import { Response } from 'shared/models/general'

import { BoughtExcursion } from './model'

export const OrderExcursions = {
  async orderExcursion(data: IExcursionsOrder) {
    const response = await clientApi.post<Response<BoughtExcursion>>(
      '/excursions/order',
      data,
    )
    void refreshOrdersCount()
    return response
  },
}
